var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_c('AuthenticationHeader'),_vm._v(" "),_c('MobileAuthenticationHeader'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('SupportWidget')],1)}
var staticRenderFns = []

export { render, staticRenderFns }